import { State } from "../../interfaces/State";
import { Project } from "../../interfaces/Project";
import { RouteComponentProps} from "react-router-dom";

interface IParams {
    projectId?: string;
}

export const getProject = ( state : State, params : RouteComponentProps<IParams>) : Project => {
    return state.projects
        .filter(site => site.id == parseInt(params.match.params.projectId))[0];
}